import {atom, useAtom} from 'jotai';
import {usePersonalScope} from '@api/workspaces';
import type {TaskPriority, TaskStatus} from '@entities/task/model/types';

/** Состояние фильтров на странице задач. */
export interface TasksFilterState {
  search: string;
  managerId?: string;
  priority?: TaskPriority;
  status?: TaskStatus;
}

const initial: TasksFilterState = {search: ''};

/** Atom состояния фильтров задач. Живёт между переходами страниц. */
export const tasksFilterAtom = atom<TasksFilterState>(initial);

/** Хук-обёртка для работы с фильтрами задач. */
export const useTasksFilter = () => {
  const [filter, setFilter] = useAtom(tasksFilterAtom);
  const scope = usePersonalScope();

  return {
    filter: scope.isPersonal ? {...filter, managerId: undefined} : filter,
    setSearch: (search: string) => setFilter((p) => ({...p, search})),
    setManagerId: (managerId?: string) => setFilter((p) => ({...p, managerId})),
    setPriority: (priority?: TaskPriority) =>
      setFilter((p) => ({...p, priority})),
    setStatus: (status?: TaskStatus) => setFilter((p) => ({...p, status})),
    reset: () => setFilter(initial),
  };
};
